import { DateFnsFormat } from '@lsq-frontend/common-ui';
import { format } from 'date-fns';

export const ACCRUED_COLLECTION_DESCRIPTION =
    'Collection Fees are the amount you pay for LSQ to track, collect, process and manage invoices and customer payments and are accrued on a daily basis.';
export const AR_BALANCE_DESCRIPTION =
    'The sum total of your purchased AR including both Eligible and Ineligible Invoices.';
export const AVAILABLE_FUNDS_DESCRIPTION =
    'The total amount of money available in your LSQ account. You can transfer these funds into your company bank account at any time.';
export const CHARGEBACKS_DESCRIPTION =
    'Invoices that have been removed from LSQ’s unpaid invoices without receipt of a payment. Commonly, invoices are “charged back” due to: non-payment, a dispute by your customer or partial payments.';
export const COLLECTIONS_DESCRIPTION =
    'Invoice payments that LSQ has received from your customers.';
export const COLLECTION_FEE_DESCRIPTION =
    'Collection Fees are the amount you pay for LSQ to track, collect, process and manage invoices and customer payments.';
export const COLLECTION_PREVIOUS_PAYMENTS_DESCRIPTION =
    'Sum of all previous payments and chargebacks associated to the invoice.';
export const COLLECTION_INVOICE_BALANCE_DESCRIPTION =
    'InvoiceBalance = InvoiceAmount + NonFactored - PaymentAmount - ChargeBacks - PreviousPayments.';
export const CREDIT_LIMIT_DESCRIPTION =
    'The dollar amount that LSQ is unable to extend because it exceeds the current credit limit for this customer.';
export const DENIED_INVOICES_DESCRIPTION =
    'Invoices that LSQ did not purchase. Often this happens because of missing supporting documentation.';
export const EXPENSES_DESCRIPTION =
    'Wire fees, Tax Guard fees, UCC filing fees, due diligence fees, etc.';
export const FEE_DESCRIPTION =
    'Fees incurred for LSQ to verify, purchase and process a new invoice. This also includes overadvance fees.';
export const FUNDS_OUTSTANDING_DESCRIPTION =
    'The outstanding balance of funds that LSQ has advanced to your account.';
export const FUNDING_DESCRIPTION =
    'The dollar amount that LSQ has paid out to you based on invoices it has purchased.';
export const FUNDING_PURCHASES_DESCRIPTION =
    'The total amount of money available to be transferred from this purchase.';
export const INELIGIBLES_DESCRIPTION =
    'Invoices that are excluded from your eligible AR. An invoice may become ineligible because it is: missing verification, past due, in dispute, etc.';
export const INELIGIBLES_PURCHASES_DESCRIPTION =
    'Invoices that LSQ will not fund against. An invoice may become ineligible because it is: missing verification, past due, over credit limit, in dispute, etc.';
export const NON_FACTORED_DESCRIPTION =
    'Payments received from your customer for invoices that were not purchased by LSQ. These payments will be added to your Available Funds Balance.';
export const PAYMENT_DESCRIPTION =
    'Invoice payments that LSQ has received from your customers including non-factored payments and chargebacked amounts.';
export const PURCHASE_DESCRIPTION = 'The total dollar amount of invoices that LSQ has purchased.';
export const REQUIRED_RESERVES_DESCRIPTION =
    'The percentage of the eligible AR you are required to maintain based on your advance rate.';
export const TOTAL_RESERVES_DESCRIPTION = 'The unfunded portion of purchased invoices.';
export const TRANSFERS_DESCRIPTION =
    'Transfers to your special reserve accounts or intra-account transfers.';

export const FACTORING_TERMS =
    'By Clicking “Upload”, you agree that pursuant to the terms of the Invoice Purchasing Agreement a/k/a/ in some instances, Factoring and Security Agreement ("Agreement"), you hereby sell, assign and transfer to LSQ all submitted receivables and provide LSQ with this assignment as evidence of your title thereto under said Agreement and as our sole factor. All warranties and representations in the Agreement as to Accounts or Receivables are hereby reaffirmed. If any third party should demand or require evidence of your purchase of all LSQ’s right, title and interests in and to the listed receivables, this Terms of Service submission may be relied upon as conclusive evidence thereof.';

export const createNoHistoricalIneligiblesDataMessage = (date: Date) =>
    `There is no data to show because we did not track this data prior to ${format(
        date,
        DateFnsFormat.SentenceFormat
    )}`;
